import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { projects } from "@/data/siteConfig";
import { SectionHeader } from "@/components/SectionHeader";
import { ProjectCard } from "@/components/ProjectCard";
import { RevealGroup, RevealItem } from "@/components/Reveal";

export const WorkPreview = () => (
  <section className="grain relative bg-ink py-24 md:py-32" data-testid="work-preview">
    <div className="relative z-10 mx-auto max-w-[1440px] px-5 md:px-8">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <SectionHeader
          overline="Our Work"
          title="Recent projects"
          description="Real project photos and videos are on the way. Below is how completed safe and locksmith work will be presented — tap any project to preview the layout."
        />
        <Link
          to="/our-work"
          data-testid="work-all-link"
          className="group inline-flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wide text-gold transition-colors hover:text-gold-soft"
        >
          View All Work
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>

      <RevealGroup className="mt-14 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
        {projects.slice(0, 3).map((p) => (
          <RevealItem key={p.id}>
            <ProjectCard project={p} />
          </RevealItem>
        ))}
      </RevealGroup>
    </div>
  </section>
);
